import React from "react";

// redux
import { useSelector } from "react-redux";

// Components
import ActionBar, {
    ActionBarLeft,
    ActionBarRight
} from "frontend/components/fort/mod/core/ActionBar";
import SelectAllAndMessaging from "./SelectAllAndMessaging";
import FlagManagement from "./FlagManagement";
import ModerationToggleBand from "./ModerationToggleBand";
import BatchApproval from "./BatchApproval";

import { QUEUES } from "../../constants";

const PhotoModQueueHeader = () => {
    const selectedBatch = useSelector(state => state.selectedBatch);
    const currentQueue = useSelector(state => state.currentQueue.name);

    return (
        <ActionBar>
            <ActionBarLeft>
                <SelectAllAndMessaging />
            </ActionBarLeft>
            {currentQueue !== QUEUES.SUSPENDED &&
                !!selectedBatch &&
                selectedBatch.id && (
                    <ActionBarRight>
                        <FlagManagement />
                        <ModerationToggleBand />
                        <BatchApproval />
                    </ActionBarRight>
                )}
        </ActionBar>
    );
};

export default PhotoModQueueHeader;
